import { CheckOutlined, CopyOutlined } from '@ant-design/icons';
import { Button, Form, message, Tooltip } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { classes } from 'src/utils/classes';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CopyButton = function CopyButton(_ref) {
  var field = _ref.field,
      horizontal = _ref.horizontal,
      children = _ref.children;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useState = useState(false),
      hasCopied = _useState[0],
      setHasCopied = _useState[1];

  function copyToClipboard(text) {
    var _navigator, _navigator$clipboard;

    if (!text) {
      return;
    }

    if ((_navigator = navigator) !== null && _navigator !== void 0 && (_navigator$clipboard = _navigator.clipboard) !== null && _navigator$clipboard !== void 0 && _navigator$clipboard.writeText) {
      navigator.clipboard.writeText(text);
      message.success(t('copiedToClipboard'));
      setHasCopied(true);
    } else {
      message.error(t('unknownError'));
    }
  }

  useEffect(function () {
    var timeout;

    if (hasCopied) {
      timeout = setTimeout(function () {
        setHasCopied(false);
      }, 5000);
    }

    return function () {
      return clearTimeout(timeout);
    };
  }, [hasCopied]);
  return /*#__PURE__*/_jsxs(Container, {
    className: classes({
      horizontal: horizontal
    }),
    children: [children, /*#__PURE__*/_jsx(Form.Item, {
      shouldUpdate: true,
      wrapperCol: {
        push: 0
      },
      className: "copy-container",
      children: function children(form) {
        return /*#__PURE__*/_jsx(Tooltip, {
          title: t('copy'),
          children: /*#__PURE__*/_jsx(Button, {
            icon: hasCopied ? /*#__PURE__*/_jsx(CheckOutlined, {}) : /*#__PURE__*/_jsx(CopyOutlined, {}),
            className: "button-copy",
            type: hasCopied ? 'primary' : 'ghost',
            disabled: !form.getFieldValue(field),
            onClick: function onClick() {
              return copyToClipboard(form.getFieldValue(field));
            }
          })
        });
      }
    })]
  });
}; // Styles

var Container = styled.div.withConfig({
  displayName: "CopyButton__Container",
  componentId: "sc-69rvwn-0"
})(["position:relative;.ant-input{padding-right:36px;}.ant-btn{svg *{transition:all 0.3s cubic-bezier(0.645,0.045,0.355,1);}}.copy-container{position:absolute;top:30px;right:0px;}&.horizontal{.ant-input{padding-right:0px;}.copy-container{position:absolute;top:0px;right:-8px;}}"]);